/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentImage from '@/components/common/more-tab-content/content-image/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentImage, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '要闻',
                    code: '14'
                },
                {
                    name: '图片新闻',
                    code: '1'
                },
                {
                    name: '法院动态',
                    code: '2'
                },
                {
                    name: '审执时讯',
                    code: '3'
                },
                {
                    name: '视频新闻',
                    code: '5'
                }
            ],
            active: '1'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'新闻资讯',
                key:'xwzx',
                path:'/xwzx'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'tpxw';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
